import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { genitourinaryCondition } from './genetourinaryCondition';

export const genetourinary: AnswerPathTreeNode = {
  path: 'genetourinary',
  children: [genitourinaryCondition],
};
